import React from 'react';
import { IconType } from '@chargify/icons';
import { Box, Button } from '../../atoms';

import { Container } from './Alert.styles';
import { Color, Size } from './types';
import { TextMessage, Title } from './components';

export interface AlertProps {
  /**
   * Alert title
   */
  title?: string;
  /**
   * Alert children
   */
  children: React.ReactNode;
  /**
   * Alert color schema
   */
  color?: Color;
  /**
   * Alert size variant
   */
  size?: Size;
  /**
   * Optional click handler
   */
  onClick?: () => void;
  /**
   * Optional button label
   */
  buttonLabel?: string;
  /**
   * Icon type displayed next to title
   */
  icon?: IconType;
}

/**
- The Alert component provides contextual feedback messages for user actions
**/
const Alert = ({
  title,
  color = 'primary',
  size = 'regular',
  buttonLabel,
  icon,
  onClick,
  children,
}: AlertProps) => {
  return (
    <Container size={size} color={color} role="alert">
      {title && <Title text={title} icon={icon} />}
      {children}
      {buttonLabel && onClick && (
        <Box marginTop={4}>
          <Button label={buttonLabel} onClick={onClick} color="secondary" />
        </Box>
      )}
    </Container>
  );
};

Alert.TextMessage = TextMessage;
Alert.Title = Title;
export default Alert;
